import React from "react";
import { CircularProgress } from "@material-ui/core";
import { Box, Button, Drawer, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AiSearchPdfDrawer = ({
  isDrawerOpen,
  setIsDrawerOpen,
  isFileDownloadLoading,
  pdfUrl
}) => {

  return (
    <Drawer
      className="drawer_pdf_box"
      anchor="right"
      open={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      PaperProps={{
        sx: {
          height: "100vh",
          width: "50%",
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #ccc",
        }}
      >
        <Typography variant="h6">View PDF</Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => setIsDrawerOpen(false)}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      {isFileDownloadLoading ? (
        <CircularProgress
          sx={{
            margin: "auto",
            display: "block",
            mt: 4,
          }}
        />
      ) : pdfUrl ? (
        <iframe
          src={`data:application/pdf;base64,${pdfUrl}`}
          title="Base64 Content"
          style={{ width: "100%", height: "100%", border: "1px solid #ccc" }}
        />
      ) : (
        <Typography
          variant="body1"
          align="center"
          sx={{
            mt: 4,
          }}
        >
          No PDF File Found.
        </Typography>
      )}
    </Drawer>
  );
};

export default AiSearchPdfDrawer;
